<template>
  <div class="appraise-audit-form">
    <Form ref="auditForm"
      v-if="formLoaded"
      :model="paper"
      label-position="left"
      :label-width="200">
      <table class="form-table">
        <thead>
          <tr>
            <th colspan="4" class="table-header">{{ this.paper.title }}</th>
          </tr>
        </thead>
        <tbody>
          <tr class="section-header">
            <td colspan="4">
              机构名称：{{ record.guarantorName }}
            </td>
          </tr>
          <section v-for="(section,sectionId) in this.paper.sections" :key="sectionId">
            <section v-if="section.isSelfAppraise">
              <tr class="section-header" v-if="section.isAttachment">
                <td colspan="4">
                  {{ section.title }}
                </td>
              </tr>
              <tr class="section-header" v-else-if="section.showTitle">
                <td colspan="4">
                  {{ section.title }} {{ section.totalScore ? `（总分值：${section.totalScore}）` : ''}}
                  <div class="section-score">{{ section.calculatedScore }}</div>
                </td>
              </tr>
              <tr class="table-row"
                v-for="(question,questionId) in section.questions" :key="questionId">
                <td width="50%">
                  <FormItem :label="question.title" :prop="`sections[${sectionId}].questions[${questionId}].value`" class="form-item"
                    v-if="[1].indexOf(question.type)>=0">
                    {{question.value}}
                    <span v-if="question.needExtInfo&&question.optionValue!==null&&question.optionValue!==undefined&&question.options&&(question.options instanceof Array)&&question.options[question.optionValue]">
                      （{{ question.options[question.optionValue].label }}）
                    </span>
                    <div v-if="question.needExtInput&&question.options&&(question.options instanceof Array)">
                      <span class="options-static" v-for="(opt,optIdx) in question.options" :key="optIdx">
                        {{ opt.label }}: {{opt.value}}
                      </span>
                    </div>
                    <div v-if="question.needExtInfo&&((question.adjustedValue!==null&&question.adjustedValue!==undefined)||(question.adjustedOptionValue!==null&&question.adjustedOptionValue!==undefined))"
                      class="font-red">
                      <b>修订值：{{ question.adjustedValue }} ({{ question.options[question.adjustedOptionValue].label }})</b>
                    </div>
                    <div v-else-if="question.needExtInput&&(question.adjustedValue!==null&&question.adjustedValue!==undefined)&&question.options&&(question.options instanceof Array)"
                      class="font-red">
                      <b>修订值：{{ question.adjustedValue }}</b><br/>
                      <span class="options-static" v-for="(opt,optIdx) in question.options" :key="optIdx">
                        {{ opt.label }}: {{opt.adjustedValue}}
                      </span>
                    </div>
                    <div v-else-if="!question.needExtInfo&&!question.needExtInput&&question.adjustedValue!==null&&question.adjustedValue!==undefined"
                      class="font-red">
                      <b>修订值：{{ question.adjustedValue }}</b>
                    </div>
                  </FormItem>
                  <FormItem :label="question.title" :prop="`sections[${sectionId}].questions[${questionId}].value`" class="form-item"
                    v-if="[0].indexOf(question.type)>=0">
                    {{question.value}}
                    <span v-if="question.needExtInfo&&question.optionValue!==null&&question.optionValue!==undefined&&question.options&&(question.options instanceof Array)&&question.options[question.optionValue]">
                      （{{ question.options[question.optionValue].label }}）
                    </span>
                    <div v-if="question.needExtInput&&question.options&&(question.options instanceof Array)">
                      <span class="options-static" v-for="(opt,optIdx) in question.options" :key="optIdx">
                        {{ opt.label }}: {{opt.value}}
                      </span>
                    </div>
                    <div v-if="question.needExtInfo&&((question.adjustedValue!==null&&question.adjustedValue!==undefined)||(question.adjustedOptionValue!==null&&question.adjustedOptionValue!==undefined))"
                      class="font-red">
                      <b>修订值：{{ question.adjustedValue }} ({{ question.options[question.adjustedOptionValue].label }})</b>
                    </div>
                    <div v-else-if="question.needExtInput&&(question.adjustedValue!==null&&question.adjustedValue!==undefined)&&question.options&&(question.options instanceof Array)"
                      class="font-red">
                      <b>修订值：{{ question.adjustedValue }}</b><br/>
                      <span class="options-static" v-for="(opt,optIdx) in question.options" :key="optIdx">
                        {{ opt.label }}: {{opt.adjustedValue}}
                      </span>
                    </div>
                    <div v-else-if="!question.needExtInfo&&!question.needExtInput&&question.adjustedValue!==null&&question.adjustedValue!==undefined"
                      class="font-red">
                      <b>修订值：{{ question.adjustedValue }}</b>
                    </div>
                  </FormItem>
                  <FormItem :label="question.title" :prop="`sections[${sectionId}].questions[${questionId}].value`" class="form-item"
                    v-if="[2].indexOf(question.type)>=0">
                    <div>{{ question.value ? '是' : '否' }}</div>
                    <FormItem label="" :prop="`sections[${sectionId}].questions[${questionId}].detail`"  
                      v-if="question.needDetail&&question.value">
                      <div style="word-break: break-all;white-space: pre-wrap;">{{ question.detail }}</div>
                    </FormItem>
                    <div v-if="question.adjustedValue!==null&&question.adjustedValue!==undefined" class="font-red">
                      <div><b>修订值：{{ question.adjustedValue ? '是' : '否' }}</b></div>
                      <div v-if="question.needDetail&&question.adjustedDetail" style="word-break: break-all;white-space: pre-wrap;">{{ question.adjustedDetail }}</div>
                    </div>
                  </FormItem>
                  <FormItem :label="question.title" :prop="`sections[${sectionId}].questions[${questionId}].value`" class="form-item"
                    v-if="[3].indexOf(question.type)>=0">
                    <div>{{ question.value ? '是' : '否' }}</div>
                    <FormItem label="" :prop="`sections[${sectionId}].questions[${questionId}].detail`"
                      v-if="question.needDetail&&question.value">
                      <div style="word-break: break-all;white-space: pre-wrap;">{{ question.detail }}</div>
                    </FormItem>
                    <div v-if="question.adjustedValue!==null&&question.adjustedValue!==undefined" class="font-red">
                      <div><b>修订值：{{ question.adjustedValue ? '是' : '否' }}</b></div>
                      <div v-if="question.needDetail&&question.adjustedDetail" style="word-break: break-all;white-space: pre-wrap;">{{ question.adjustedDetail }}</div>
                    </div>
                  </FormItem>
                  <FormItem :label="question.title" :prop="`sections[${sectionId}].questions[${questionId}].value`" class="form-item"
                    v-if="[6].indexOf(question.type)>=0">
                    <div v-if="question.options&&(question.options instanceof Array)&&question.options[question.value]">{{ question.options[question.value].label }}</div>
                    <div v-if="question.options&&(question.options instanceof Array)&&question.options[question.adjustedValue]" class="font-red"><b>修订值：{{ question.options[question.adjustedValue].label }}</b></div>
                  </FormItem>
                  <FormItem :label="question.title" :prop="`sections[${sectionId}].questions[${questionId}].value`" class="form-item"
                    v-if="[4].indexOf(question.type)>=0">
                    <div class="question-list-type">
                      <div class="question-list-item-list" v-if="question.value && (question.value instanceof Array) && question.value.length">
                        <div class="question-list-item"
                          v-for="(listItem, listItemIdx) in question.value"
                          :key="listItemIdx">
                          <FormItem style="flex:1" label="" :prop="`sections[${sectionId}].questions[${questionId}].value[${listItemIdx}].value`">
                            <div style="word-break: break-all;white-space: pre-wrap;">{{ listItem.value }}</div>
                          </FormItem>
                        </div>
                      </div>
                      <div v-else>无</div>
                      <div v-if="question.adjustedValue && (question.adjustedValue instanceof Array)" class="font-red"><b>修订值：</b></div>
                      <div class="question-list-item-list adjust" v-if="question.adjustedValue && (question.adjustedValue instanceof Array)">
                        <div class="question-list-item"
                          v-for="(listItem, listItemIdx) in question.adjustedValue"
                          :key="listItemIdx">
                          <FormItem style="flex:1" label="" :prop="`sections[${sectionId}].questions[${questionId}].adjustedValue[${listItemIdx}].value`">
                            <div style="word-break: break-all;white-space: pre-wrap;">{{ listItem.value }}</div>
                          </FormItem>
                        </div>
                      </div>
                    </div>
                  </FormItem>
                  <FormItem :label="question.title" :prop="`sections[${sectionId}].questions[${questionId}].value`" class="form-item"
                    v-if="[7].indexOf(question.type)>=0">
                    <div class="question-list-type">
                      <div class="question-list-item-list" v-if="question.value && (question.value instanceof Array) && question.value.length">
                        <div class="question-list-item"
                          v-for="(listItem, listItemIdx) in question.value"
                          :key="listItemIdx">
                          <FormItem style="flex:1" label="" :prop="`sections[${sectionId}].questions[${questionId}].value[${listItemIdx}].value`">
                            <div v-if="question.options&&(question.options instanceof Array)&&question.options.find(o=>o.value===listItem.value)">{{ question.options.find(o=>o.value===listItem.value).label }}</div>
                            <div style="word-break: break-all;white-space: pre-wrap;">{{ listItem.detail }}</div>
                          </FormItem>
                        </div>
                      </div>
                      <div v-else>无</div>
                      <div v-if="question.adjustedValue && (question.adjustedValue instanceof Array)" class="font-red"><b>修订值：</b></div>
                      <div class="question-list-item-list adjust" v-if="question.adjustedValue && (question.adjustedValue instanceof Array)">
                        <div class="question-list-item"
                          v-for="(listItem, listItemIdx) in question.adjustedValue"
                          :key="listItemIdx">
                          <FormItem style="flex:1" label="" :prop="`sections[${sectionId}].questions[${questionId}].adjustedValue[${listItemIdx}].value`">
                            <div v-if="question.options&&(question.options instanceof Array)&&question.options.find(o=>o.value===listItem.value)">{{ question.options.find(o=>o.value===listItem.value).label }}</div>
                            <div style="word-break: break-all;white-space: pre-wrap;">{{ listItem.detail }}</div>
                          </FormItem>
                        </div>
                      </div>
                    </div>
                  </FormItem>
                  <FormItem :label="question.title" :prop="`sections[${sectionId}].questions[${questionId}].url`" class="form-item"
                    v-if="[5].indexOf(question.type)>=0">
                    <div class="attachments">
                      <div class="attachment-thumb"
                        @click="previewImgUrl=item;showPreview=true"
                        :key="index"
                        v-for="(item,index) in question.url">
                        <img :src="item.url" v-if="item&&item.url&&item.type==='image'">
                        <span style="font-weight:bold;color:#999" v-if="item&&item.url&&item.type==='file'">{{item.surfix.toUpperCase()}}</span>
                        <div class="attachment-thumb-cover">
                          <Icon type="ios-eye-outline" @click.stop="previewImgUrl=item;showPreview=true"></Icon>
                        </div>
                      </div>
                    </div>
                  </FormItem>
                </td>
                <td width="50%" class="item-extra-td">
                  <div class="description">
                    {{ question.description }}
                  </div>
                  <div class="score">
                    <div v-if="!section.isAttachment">自评得分：{{ question.calculatedScore }}</div>
                    <div v-if="!section.isAttachment&&question.adjustedScore!==undefined&&question.adjustedScore!==null" class="font-red"><b>修订得分：{{ question.adjustedScore }}</b></div>
                    <div v-if="!section.isAttachment">
                      <Button type="primary" size="small" ghost @click="adjustQuestion(question)">修订</Button>
                    </div>
                  </div>
                </td>
              </tr>
            </section>
            <section v-if="!section.isSelfAppraise">
              <tr class="section-header" if="section.showTitle">
                <td colspan="4">
                  {{ section.title }} {{ section.totalScore ? `（总分值：${section.totalScore}）` : ''}}
                  <div class="section-score">{{ section.calculatedScore }}</div>
                </td>
              </tr>
              <tr class="table-row"
                v-for="(question,questionId) in section.questions" :key="questionId">
                <td width="50%">
                  <FormItem :label="question.title" :prop="`sections[${sectionId}].questions[${questionId}].value`" class="form-item"
                    v-if="[1].indexOf(question.type)>=0"
                    :rules="[{required:true,type:'number',message:'请填写',trigger:'blur'}]">
                    <InputNumber :disabled="question.disabled" :name="question.name" v-model="question.value" @on-change="calculateQuestion(question)" />
                    <FormItem label="" v-if="question.extInfo&&question.needExtInfo" class="padding0"
                      :rules="[{required:true,type:'number',message:'请选择',trigger:'blur'}]"
                      :prop="`sections[${sectionId}].questions[${questionId}].optionValue`"
                      style="display:inline-block;padding:4px 8px">
                      <Select style="width:200px;margin-top:-8px;" v-model="question.optionValue" filterable v-if="question.options && (question.options instanceof Array)" @on-change="calculateQuestion(question)">
                        <Option v-for="(opt,optIdx) in question.options" :key="optIdx" :value="opt.value">{{opt.label}}</Option>
                      </Select>
                    </FormItem>
                    <section class="inline-formitem"
                      v-if="question.extInfo&&question.needExtInput&&question.options.length">
                      <FormItem :label="opt.label" class="padding0"
                        v-for="(opt,optIdx) in question.options" :key="optIdx"
                        :rules="[{required:true,type:opt.type,message:'请输入',trigger:'blur'}]"
                        :prop="`sections[${sectionId}].questions[${questionId}].options[${optIdx}].value`"
                        style="display:inline-block;">
                        <InputNumber v-if="'number'===opt.type" v-model="opt.value" @on-change="calculateQuestion(question)" />
                        <Input v-else-if="'text'===opt.type" v-model="opt.value" style="width:200px" @on-change="calculateQuestion(question)" />
                      </FormItem>
                    </section>
                  </FormItem>
                  <FormItem :label="question.title" :prop="`sections[${sectionId}].questions[${questionId}].value`" class="form-item"
                    v-if="[0].indexOf(question.type)>=0"
                    :rules="[{required:true,message:'请填写',trigger:'blur'}]">
                    <Input :name="question.name" v-model="question.value" @on-change="calculateQuestion(question)" />
                    <FormItem label="" v-if="question.extInfo&&question.needExtInfo" class="padding0"
                      :rules="[{required:true,type:'number',message:'请选择',trigger:'blur'}]"
                      :prop="`sections[${sectionId}].questions[${questionId}].optionValue`"
                      style="display:inline-block;padding:4px 8px">
                      <Select style="width:200px;margin-top:-8px;" v-model="question.optionValue" filterable v-if="question.options && (question.options instanceof Array)" @on-change="calculateQuestion(question)">
                        <Option v-for="(opt,optIdx) in question.options" :key="optIdx" :value="opt.value">{{opt.label}}</Option>
                      </Select>
                    </FormItem>
                    <section class="inline-formitem"
                      v-if="question.extInfo&&question.needExtInput&&question.options.length">
                      <FormItem :label="opt.label" class="padding0"
                        v-for="(opt,optIdx) in question.options" :key="optIdx"
                        :rules="[{required:true,type:opt.type,message:'请输入',trigger:'blur'}]"
                        :prop="`sections[${sectionId}].questions[${questionId}].options[${optIdx}].value`"
                        style="display:inline-block;">
                        <InputNumber v-if="'number'===opt.type" v-model="opt.value" @on-change="calculateQuestion(question)" />
                        <Input v-else-if="'text'===opt.type" v-model="opt.value" style="width:200px" @on-change="calculateQuestion(question)" />
                      </FormItem>
                    </section>
                  </FormItem>
                  <FormItem :label="question.title" :prop="`sections[${sectionId}].questions[${questionId}].value`" class="form-item"
                    v-if="[2].indexOf(question.type)>=0">
                    <i-switch :name="question.name" v-model="question.value" @on-change="calculateQuestion(question)" />
                    <FormItem label="" :prop="`sections[${sectionId}].questions[${questionId}].detail`"
                      :rules="[{required:true,message:'请填写',trigger:'blur'}]"  
                      v-if="question.needDetail&&question.value">
                      <Input type="textarea" v-model="question.detail" placeholder="详细情况" />
                    </FormItem>
                  </FormItem>
                  <FormItem :label="question.title" :prop="`sections[${sectionId}].questions[${questionId}].value`" class="form-item"
                    v-if="[3].indexOf(question.type)>=0">
                    <i-switch :name="question.name" v-model="question.value" @on-change="calculateQuestion(question)" />
                    <FormItem label="" :prop="`sections[${sectionId}].questions[${questionId}].detail`"
                      :rules="[{required:true,message:'请填写',trigger:'blur'}]"  
                      v-if="question.needDetail&&question.value">
                      <Input type="textarea" v-model="question.detail" placeholder="详细情况" />
                    </FormItem>
                  </FormItem>
                  <FormItem :label="question.title" :prop="`sections[${sectionId}].questions[${questionId}].value`" class="form-item"
                    v-if="[6].indexOf(question.type)>=0"
                    :rules="[{required:true,type:'number',message:'请填写',trigger:'blur'}]">
                    <Select v-model="question.value" filterable v-if="question.options && (question.options instanceof Array)" @on-change="calculateQuestion(question)">
                      <Option v-for="(opt,optIdx) in question.options" :key="optIdx" :value="opt.value">{{opt.label}}</Option>
                    </Select>
                  </FormItem>
                  <FormItem :label="question.title" :prop="`sections[${sectionId}].questions[${questionId}].value`" class="form-item"
                    v-if="[4].indexOf(question.type)>=0">
                    <div class="question-list-type">
                      <div class="question-list-item-list" v-if="question.value && (question.value instanceof Array)">
                        <div class="question-list-item"
                          v-for="(listItem, listItemIdx) in question.value"
                          :key="listItemIdx">
                          <FormItem style="flex:1" label="" :prop="`sections[${sectionId}].questions[${questionId}].value[${listItemIdx}].value`"
                            :rules="[{required:true,message:'请填写',trigger:'blur'}]">
                            <Input type="textarea" v-model="listItem.value" :placeholder="listItem.placeholder" />
                          </FormItem>
                          <Button icon="md-remove" shape="circle" type="error" ghost @click="removeListItem(listItem, question)" style="margin-left:5px"></Button>
                        </div>
                      </div>
                      <Button type="primary" ghost long icon="md-add"
                        @click="addListItem(question)">
                        增加{{ question.title }}</Button>
                    </div>
                  </FormItem>
                  <FormItem :label="question.title" :prop="`sections[${sectionId}].questions[${questionId}].value`" class="form-item"
                    v-if="[7].indexOf(question.type)>=0">
                    <div class="question-list-type">
                      <div class="question-list-item-list" v-if="question.value && (question.value instanceof Array)">
                        <div class="question-list-item"
                          v-for="(listItem, listItemIdx) in question.value"
                          :key="listItemIdx">
                          <FormItem label="" :prop="`sections[${sectionId}].questions[${questionId}].value[${listItemIdx}].value`"
                            :rules="[{required:true,message:'请选择',trigger:'blur'}]">
                            <Select v-model="listItem.value" filterable style="width:100px"
                              v-if="question.options && (question.options instanceof Array)"
                              @on-change="calculateQuestion(question)">
                              <Option v-for="(opt,optIdx) in question.options" :key="optIdx" :value="opt.value">{{opt.label}}</Option>
                            </Select>
                          </FormItem>
                          <FormItem style="flex:1" label="" :prop="`sections[${sectionId}].questions[${questionId}].value[${listItemIdx}].detail`"
                            :rules="[{required:true,message:'请填写',trigger:'blur'}]">
                            <Input type="textarea" v-model="listItem.detail" :placeholder="listItem.placeholder" />
                          </FormItem>
                          <Button icon="md-remove" size="small" shape="circle" type="error" ghost @click="removeListItem(listItem, question)" style="margin-left:5px"></Button>
                        </div>
                      </div>
                      <Button type="primary" ghost long icon="md-add"
                        @click="addListItem(question)">
                        增加{{ question.title }}</Button>
                    </div>
                  </FormItem>
                </td>
                <td width="50%" class="item-extra-td">
                  <div class="description">
                    {{ question.description }}
                  </div>
                  <div class="score">
                    <div v-if="!section.isAttachment">本项得分：{{ question.calculatedScore || question.calculatedScore === 0 ? question.calculatedScore.toFixed(2) : '-' }}</div>
                  </div>
                </td>
              </tr>
            </section>
          </section>
        </tbody>
        <tfoot>
          <tr class="section-header">
            <td colspan="4">
              自评总分： {{ paper.calculatedScore.toFixed(2)}}
            </td>
          </tr>
          <tr class="section-header">
            <td colspan="4">
              审核总分： {{ paper.adjustedScore.toFixed(2)}}
            </td>
          </tr>
          <tr class="section-header">
            <td colspan="4">
              <FormItem label="最终评级" prop="grade" :label-width="100"
                :rules="[{required:true,message:'请填写评级等级',trigger:'blur'}]"
                style="width:100%;padding-top:5px;">
                <Input v-model="paper.grade" placeholder="填写评级等级" />
              </FormItem>
            </td>
          </tr>
          <tr class="section-header">
            <td colspan="4">
              备注： <Input v-model="paper.remark" type="textarea" autosize style="min-width:600px" placeholder="填写评级备注" />
            </td>
          </tr>
        </tfoot>
      </table>
    </Form>
    <Row :gutter="32" v-if="formLoaded">
      <i-col span="12">
        <Button type="info" size="large" long @click="calculate()">试算</Button>
      </i-col>
      <i-col span="12">
        <Button type="primary" size="large" long @click="submit">审核</Button>
      </i-col>
    </Row>
    <div class="full" v-if="!formLoaded">
      <Spin fix>加载中...</Spin>
    </div>
    <Modal v-model="showPreview" title="查看图片" @on-cancel="showPreview=false;previewImgUrl=null">
      <img :src="previewImgUrl" v-if="showPreview&&typeof(previewImgUrl)==='string'" style="width: 100%">
      <img :src="previewImgUrl.url" v-if="showPreview&&typeof(previewImgUrl)==='object'&&previewImgUrl.url&&previewImgUrl.type==='image'" style="width: 100%">
      <a :href="previewImgUrl.url" target="_blank" v-if="showPreview&&typeof(previewImgUrl)==='object'&&previewImgUrl.url&&previewImgUrl.type==='file'">查看</a>
    </Modal>
    <Modal :mask-closable="false" v-model="showAdjustModal" title="修订项目" @on-cancel="closeAdjustModal" @on-ok="confirmAdjust">
      <div v-if="currentQuestion&&currentQuestion.name">
        <Form ref="adjustForm" :model="currentQuestion" :label-width="160" labelPosition="left">
          <FormItem :label="currentQuestion.title" prop="adjustedValue"
            v-if="[1].indexOf(currentQuestion.type)>=0"
            :rules="[{required:true,type:'number',message:'请填写',trigger:'blur'}]">
            <InputNumber :disabled="currentQuestion.disabled" v-model="currentQuestion.adjustedValue" @on-change="calculateQuestion(currentQuestion)" />
            <FormItem label="" v-if="currentQuestion.extInfo&&currentQuestion.needExtInfo"
              :rules="[{required:true,type:'number',message:'请选择',trigger:'blur'}]"
              prop="adjustedOptionValue"
              style="display:inline-block;padding:0 8px">
              <Select style="width:200px" v-model="currentQuestion.adjustedOptionValue" filterable v-if="currentQuestion.options && (currentQuestion.options instanceof Array)" @on-change="calculateQuestion(currentQuestion)">
                <Option v-for="(opt,optIdx) in currentQuestion.options" :key="optIdx" :value="opt.value">{{opt.label}}</Option>
              </Select>
            </FormItem>
            <section class="inline-formitem"
              v-if="currentQuestion.extInfo&&currentQuestion.needExtInput&&currentQuestion.options.length">
              <FormItem :label="opt.label" class="padding0"
                v-for="(opt,optIdx) in currentQuestion.options" :key="optIdx"
                :rules="[{required:true,type:opt.type,message:'请输入',trigger:'blur'}]"
                :prop="`options[${optIdx}].adjustedValue`"
                style="display:inline-block;">
                <InputNumber v-if="'number'===opt.type" v-model="opt.adjustedValue" @on-change="calculateQuestion(currentQuestion)" />
                <Input v-else-if="'text'===opt.type" v-model="opt.adjustedValue" style="width:200px" @on-change="calculateQuestion(currentQuestion)" />
              </FormItem>
            </section>
          </FormItem>
          <FormItem :label="currentQuestion.title" prop="adjustedValue"
            v-if="[0].indexOf(currentQuestion.type)>=0"
            :rules="[{required:true,message:'请填写',trigger:'blur'}]">
            <Input :disabled="currentQuestion.disabled" v-model="currentQuestion.adjustedValue" @on-change="calculateQuestion(currentQuestion)" />
            <FormItem label="" v-if="currentQuestion.extInfo"
              :rules="[{required:true,type:'number',message:'请选择',trigger:'blur'}]"
              prop="adjustedOptionValue"
              style="display:inline-block;padding:0 8px">
              <Select style="width:200px" v-model="currentQuestion.adjustedOptionValue" filterable v-if="currentQuestion.options && (currentQuestion.options instanceof Array)" @on-change="calculateQuestion(currentQuestion)">
                <Option v-for="(opt,optIdx) in currentQuestion.options" :key="optIdx" :value="opt.value">{{opt.label}}</Option>
              </Select>
            </FormItem>
            <section class="inline-formitem"
              v-if="currentQuestion.extInfo&&currentQuestion.needExtInput&&currentQuestion.options.length">
              <FormItem :label="opt.label" class="padding0"
                v-for="(opt,optIdx) in currentQuestion.options" :key="optIdx"
                :rules="[{required:true,type:opt.type,message:'请输入',trigger:'blur'}]"
                :prop="`options[${optIdx}].adjustedValue`"
                style="display:inline-block;">
                <InputNumber v-if="'number'===opt.type" v-model="opt.adjustedValue" @on-change="calculateQuestion(currentQuestion)" />
                <Input v-else-if="'text'===opt.type" v-model="opt.adjustedValue" style="width:200px" @on-change="calculateQuestion(currentQuestion)" />
              </FormItem>
            </section>
          </FormItem>
          <FormItem :label="currentQuestion.title" prop="adjustedValue"
            v-if="[2,3].indexOf(currentQuestion.type)>=0">
            <i-switch v-model="currentQuestion.adjustedValue" @on-change="calculateQuestion(currentQuestion)" />
            <FormItem label="" prop="adjustedDetail"
              :rules="[{required:true,message:'请填写',trigger:'blur'}]"  
              v-if="currentQuestion.needDetail&&currentQuestion.adjustedValue">
              <Input type="textarea" v-model="currentQuestion.adjustedDetail" placeholder="详细情况" />
            </FormItem>
          </FormItem>
          <FormItem :label="currentQuestion.title" prop="adjustedValue"
            v-if="[6].indexOf(currentQuestion.type)>=0"
            :rules="[{required:true,type:'number',message:'请填写',trigger:'blur'}]">
            <Select v-model="currentQuestion.adjustedValue" filterable v-if="currentQuestion.options && (currentQuestion.options instanceof Array)" @on-change="calculateQuestion(currentQuestion)">
              <Option v-for="(opt,optIdx) in currentQuestion.options" :key="optIdx" :value="opt.value">{{opt.label}}</Option>
            </Select>
          </FormItem>
          <FormItem :label="currentQuestion.title" prop="adjustedValue"
            v-if="[4].indexOf(currentQuestion.type)>=0">
            <div class="question-list-type">
              <div class="question-list-item-list" v-if="currentQuestion.adjustedValue && (currentQuestion.adjustedValue instanceof Array)">
                <div class="question-list-item"
                  v-for="(listItem, listItemIdx) in currentQuestion.adjustedValue"
                  :key="listItemIdx">
                  <FormItem style="flex:1" label="" :prop="`adjustedValue[${listItemIdx}].value`"
                    :rules="[{required:true,message:'请填写',trigger:'blur'}]">
                    <Input type="textarea" v-model="listItem.value" :placeholder="listItem.placeholder" />
                  </FormItem>
                  <Button icon="md-remove" shape="circle" type="error" ghost @click="removeAdjustedListItem(listItem, currentQuestion)" style="margin-left:5px"></Button>
                </div>
              </div>
              <Button type="primary" ghost long icon="md-add"
                @click="addAdjustedListItem(currentQuestion)">
                增加{{ currentQuestion.title }}</Button>
            </div>
          </FormItem>
          <FormItem :label="currentQuestion.title" prop="adjustedValue"
            v-if="[7].indexOf(currentQuestion.type)>=0">
            <div class="question-list-type">
              <div class="question-list-item-list" v-if="currentQuestion.adjustedValue && (currentQuestion.adjustedValue instanceof Array)">
                <div class="question-list-item"
                  v-for="(listItem, listItemIdx) in currentQuestion.adjustedValue"
                  :key="listItemIdx">
                  <FormItem label="" :prop="`adjustedValue[${listItemIdx}].value`"
                    :rules="[{required:true,message:'请选择',trigger:'blur'}]">
                    <Select v-model="listItem.value" filterable style="width:100px"
                      v-if="currentQuestion.options && (currentQuestion.options instanceof Array)"
                      @on-change="calculateQuestion(currentQuestion)">
                      <Option v-for="(opt,optIdx) in currentQuestion.options" :key="optIdx" :value="opt.value">{{opt.label}}</Option>
                    </Select>
                  </FormItem>
                  <FormItem style="flex:1" label="" :prop="`adjustedValue[${listItemIdx}].detail`"
                    :rules="[{required:true,message:'请填写',trigger:'blur'}]">
                    <Input type="textarea" v-model="listItem.detail" :placeholder="listItem.placeholder" />
                  </FormItem>
                  <Button icon="md-remove" size="small" shape="circle" type="error" ghost @click="removeAdjustedListItem(listItem, currentQuestion)" style="margin-left:5px"></Button>
                </div>
              </div>
              <Button type="primary" ghost long icon="md-add"
                @click="addAdjustedListItem(currentQuestion)">
                增加{{ currentQuestion.title }}</Button>
            </div>
          </FormItem>
        </Form>
      </div>
    </Modal>
  </div>
</template>

<script>
import Api from '../../api/Api.js'
import * as math from 'mathjs'
export default {
  data () {
    return {
      loading: false,
      paper: {},
      formLoaded: false,
      isVeto: false, // 一票否决
      uploadParams: {
        accessid: '',
        host: '',
        policy: '',
        signature: '',
        callbackbody: '',
        key: '',
        expire: 0
      },
      OSSParams: [],
      OSSParam: {
        name: '',
        key: '',
        policy: '',
        OSSAccessKeyId: '',
        success_action_status: '200',   // 让服务端返回200,不然，默认会返回204
        signature: '',
        fileIndex: 0
      },
      curOSSParamIndex: 0,
      previewImgUrl: null,
      showPreview: false,
      record: null,
      showAdjustModal: false,
      currentQuestion: {
        tid: null,
        name: null,
        title: null,
        type: null,
        description: null,
        defaultValue: null,
        scoreFormula: null,
        needDetail: false,
        needExtInfo: false,
        needExtInput: false,
        extInfo: null,
        options: [],
        isRequired: true,
        value: null,
        calculatedScore: null,
        detail: null,
        adjustedValue: null,
        adjustedScore: null,
        adjustedOptionValue: null
      },
      globalVars: {}
    }
  },
  mounted () {
    this.initForm()
  },
  methods: {
    adjustQuestion (question) {
      if (question) {
        console.log(question)
        this.currentQuestion.tid = question.tid
        this.currentQuestion.name = question.name
        this.currentQuestion.title = question.title
        this.currentQuestion.type = question.type
        this.currentQuestion.description = question.description
        this.currentQuestion.value = question.value
        this.currentQuestion.scoreFormula = question.scoreFormula
        this.currentQuestion.defaultValue = question.defaultValue
        if (question.type === 4) {
          this.currentQuestion.adjustedValue = JSON.parse(JSON.stringify(question.value))
          this.currentQuestion.adjustedScore = JSON.parse(JSON.stringify(question.calculatedScore))
        } else if (question.type === 7) {
          this.currentQuestion.extInfo = question.extInfo
          this.currentQuestion.options = JSON.parse(question.extInfo)
          this.currentQuestion.adjustedValue = JSON.parse(JSON.stringify(question.value))
          this.currentQuestion.adjustedScore = JSON.parse(JSON.stringify(question.calculatedScore))
        } else {
          this.currentQuestion.adjustedValue = question.value
          this.currentQuestion.adjustedScore = question.calculatedScore
        }
        if (question.extInfo) {
          console.log(question.extInfo)
          this.currentQuestion.extInfo = question.extInfo
          this.currentQuestion.options = JSON.parse(question.extInfo)
          if (question.needExtInfo) {
            this.currentQuestion.needExtInfo = true
          }
          if (question.needExtInput) {
            this.currentQuestion.needExtInput = true
            this.currentQuestion.options.forEach((opt, optIdx) => {
              opt.value = question.options[optIdx].value
              opt.adjustedValue = question.options[optIdx].value
            })
          }
          if (question.disabled) {
            this.currentQuestion.disabled = true
          }
        }
        if (question.optionValue !== null && question.optionValue !== undefined) {
          this.currentQuestion.adjustedOptionValue = question.optionValue
        }
        if (question.detail) {
          this.currentQuestion.adjustedDetail = question.detail
          this.currentQuestion.detail = question.detail
        }
        this.showAdjustModal = true
        console.log(question, this.paper)
      }
    },
    closeAdjustModal () {
      this.showAdjustModal = false
      this.currentQuestion = {
        tid: null,
        name: null,
        title: null,
        type: null,
        description: null,
        defaultValue: null,
        scoreFormula: null,
        needDetail: false,
        needExtInfo: false,
        needExtInput: false,
        extInfo: null,
        options: [],
        isRequired: true,
        value: null,
        calculatedScore: null,
        detail: null,
        adjustedValue: null,
        adjustedScore: null
      }
      console.log('close', this.paper)
    },
    confirmAdjust () {
      if (!this.currentQuestion || !this.currentQuestion.name) {
        return false
      }
      let question = null
      this.paper.sections.forEach((s) => {
        s.questions.forEach((q) => {
          if (q.tid === this.currentQuestion.tid) {
            question = q
            question.adjustedValue = this.currentQuestion.adjustedValue
            question.adjustedScore = this.currentQuestion.adjustedScore
            if (this.currentQuestion.adjustedOptionValue !== null && this.currentQuestion.adjustedOptionValue !== undefined) {
              question.adjustedOptionValue = this.currentQuestion.adjustedOptionValue
            }
            if (this.currentQuestion.needExtInput) {
              this.currentQuestion.options.forEach((opt, optIdx) => {
                if (opt.adjustedValue !== null && opt.adjustedValue !== undefined) {
                  question.options[optIdx].adjustedValue = opt.adjustedValue
                }
              })
            }
            console.log(question)
          }
        })
      })
      this.calculate(question.name)
      this.showAdjustModal = false
      this.currentQuestion = {
        tid: null,
        name: null,
        title: null,
        type: null,
        description: null,
        defaultValue: null,
        scoreFormula: null,
        needDetail: false,
        needExtInfo: false,
        needExtInput: false,
        extInfo: null,
        options: [],
        isRequired: true,
        value: null,
        calculatedScore: null,
        detail: null,
        adjustedValue: null,
        adjustedScore: null,
        adjustedOptionValue: null
      }
      console.log('confirm', this.paper)
    },
    async getAppraisalRecordData () {
      if (this.$route.params.recordId) {
        this.formLoaded = false
        let record = await Api.Appraisal.getAppraisalRecord(this.$route.params.recordId)
          .catch(err => {
            this.$Notice.error({
              title: '获取记录失败!',
              desc: err.message
            })
            return Promise.reject('获取记录失败!')
          })
        // console.log(record)
        this.record = record
        if (!record.rawJson) {
          this.$Notice.error({
            title: '数据不正确!',
            desc: '原始数据不正确'
          })
          return Promise.reject('数据不正确!')
        }
        let paper = {}
        try {
          paper = JSON.parse(record.rawJson)
        } catch (err) {
          this.$Notice.error({
            title: '数据不正确!',
            desc: err.message
          })
          return Promise.reject('数据不正确!')
        }
        if (record.status === 1) {
          // 处理原始数据
          if (!paper.sections) {
            this.$Notice.error({
              title: '数据不正确!',
              desc: '原始数据不正确'
            })
            return Promise.reject('数据不正确!')
          }
          paper.sections.forEach((section) => {
            if (section.isAttachment) {
              if (!section.questions) {
                section.questions = []
              }
              section.questions.forEach((q) => {
                if (q.ossKeys) {
                  q.filePath = ''
                  q.url = []
                  q.ossKeys.forEach((o) => {
                    this.$nextTick(() => {
                      let key = o.indexOf('oss:') === 0 ? o.substr(4) : o
                      this.procOssKey(key).then(url => {
                        url.status = 'finished'
                        q.url.push(url)
                      })
                    })
                  })
                  q.filePath = q.ossKeys.join(',')
                }
                // 记录全局变量
                if (q.scoreFormula) {
                  let globalRefRegx = /\$[A-Za-z0-9]\w+\$/g
                  let matches = Array.from(q.scoreFormula.matchAll(globalRefRegx))
                  matches.forEach((match) => {
                    let variable = match[0]
                    let variableName = variable.substr(1, variable.length - 2)
                    let globalVar = this.globalVars[variableName]
                    if (!globalVar) {
                      this.globalVars[variableName] = [q.name]
                    } else {
                      globalVar.push(q.name)
                      this.globalVars[variableName] = Array.from(new Set(globalVar))
                    }
                  })
                }
              })
            } else {
              // if (section.questions && section.questions instanceof Array) {
              //   section.questions.forEach((q) => {
              //     q.adjustedValue = q.value
              //     q.adjustedScore = q.calculatedScore
              //     if (q.detail) {
              //       q.adjustedDetail = q.detail
              //     }
              //   })
              // }
            }
          })
          paper.adjustedScore = 0
          paper.grade = null
          this.paper = paper
          console.log(paper)
          this.formLoaded = true
          return Promise.resolve()
        } else {
          this.$Notice.error({
            title: '状态不正确!',
            desc: '当前状态不是待审核状态'
          })
          this.$router.back()
          return Promise.reject('状态不正确!')
        }
      }
    },
    async initForm () {
      await this.getAppraisalRecordData()
    },
    getConfig (key) {
      return this.$store.getters.sysConfigs[key]
    },
    arrayValidator (rule, value, callback) {
      if (!value || !(value instanceof Array) || !value.length) {
        callback(new Error('没有元素'))
      } else {
        callback()
      }
    },
    getFormats (fmtStr) {
      if (!fmtStr) {
        return ['pdf', 'jpg', 'jpeg', 'png']
      }
      let arr = fmtStr.split(',')
      let result = arr.map((a) => {
        return a.trim()
      })
      return result
    },
    getOSSParams (index) {
      this.$Api.Guarantor.getUploadParams('appraise').then((res) => {
        console.log(res)
        this.uploadParams = {
          accessid: res.accessid,
          host: res.host,
          policy: res.policy,
          signature: res.signature,
          callbackbody: res.callbackbody,
          key: res.dir,
          expire: res.expire
        }
        this.uploadParams.host = this.uploadParams.host.replace('-internal', '')
        this.curOSSParamIndex = index    // 上传控件序号
      }).catch(err => {
        this.$Message.error(err.message)
      })
    },
    handleBeforeUpload (file) {
      let filename = this.uploadParams.key + this.randomString(10) + this.getSuffix(file.name)
      this.OSSParams[this.curOSSParamIndex] = {
        name: file.name,
        key: filename,
        policy: this.uploadParams.policy,
        OSSAccessKeyId: this.uploadParams.accessid,
        success_action_status: '200',   // 让服务端返回200,不然，默认会返回204
        signature: this.uploadParams.signature,
        fileIndex: this.curOSSParamIndex
      }
      this.OSSParam.name = file.name
      this.OSSParam.key = filename
      this.OSSParam.policy = this.uploadParams.policy
      this.OSSParam.OSSAccessKeyId = this.uploadParams.accessid
      this.OSSParam.success_action_status = '200'   // 让服务端返回200,不然，默认会返回204
      this.OSSParam.signature = this.uploadParams.signature
      this.OSSParam.fileIndex = this.curOSSParamIndex
      console.log(this.OSSParams, file)
    },
    async handleUploadSuccess (response, file, fileList) {
      let ossParam = this.OSSParams.find(o => o && o.name === file.name)
      console.log(ossParam, file, fileList)
      if (!ossParam) {
        return false
      }
      let index = ossParam.fileIndex
      let attachSection = this.paper.sections.find(o => o.isAttachment)
      let attach = attachSection.questions[index]
      if (fileList.length > attach.fileCountLimit) {
        fileList.splice(0, 1)
        attach.ossKeys.splice(0, 1)
      }
      if (!attach.ossKeys) {
        attach.ossKeys = []
      }
      if (!attach.url) {
        attach.url = []
      }
      let filename = 'oss:' + ossParam.key
      file.name = filename
      this.$nextTick(async () => {
        await this.procOssKey(filename).then(url => {
          url.status = 'finished'
          attach.url.push(url)
        })
        attach.ossKeys.push(filename)
        attach.filePath = attach.ossKeys.join(',')
        console.log(attachSection)
      })
    },
    removeItem (item, attachIdx) {
      let attachSection = this.paper.sections.find(o => o.isAttachment)
      let attach = attachSection.questions[attachIdx]
      let idx = attach.url.findIndex(o => o.name === item.name)
      attach.url.splice(idx, 1)
      let keys = attach.filePath.split(',')
      keys.splice(idx, 1)
      keys = keys.join(',')
      console.log(keys)
      attach[attachIdx].ossKeys = keys
      attach[attachIdx].filePath = keys
    },
    previewUploaded (file) {
      let key = file.name.indexOf('oss:') === 0 ? file.name.substr(4) : file.name
      this.procOssKey(key).then((obj) => {
        console.log(obj)
        this.previewImgUrl = obj.url
        this.showPreview = true
      })
    },
    async procOssKey (k) {
      let url = await this.procOSSUrl(k)
      return new Promise((resolve) => {
        let surfix = url.substr(url.lastIndexOf('.') + 1).toLowerCase()
        if (surfix.indexOf('?')) {
          surfix = surfix.substring(0, surfix.indexOf('?'))
        }
        let type = 'image'
        switch (surfix) {
          case 'jpg':
            type = 'image'
            break
          case 'jpeg':
            type = 'image'
            break
          case 'png':
            type = 'image'
            break
          case 'gif':
            type = 'image'
            break
          case 'pdf':
            type = 'file'
            break
          case 'doc':
            type = 'file'
            break
          case 'docx':
            type = 'file'
            break
          case 'xls':
            type = 'file'
            break
          case 'xlsx':
            type = 'file'
            break
          case 'ppt':
            type = 'file'
            break
          case 'pptx':
            type = 'file'
            break
          default:
            type = 'file'
            break
        }
        resolve({
          name: k,
          url,
          type,
          surfix
        })
      })
    },
    procOSSUrl (_key) {
      return new Promise((resolve, reject) => {
        let url = ''
        let ossKey = window.encodeURIComponent(window.btoa(_key))
        Api.Guarantee.getOssUrl(ossKey).then((res) => {
          // console.log(typeof(res), res)
          url = res
          resolve(url)
        }).catch(err => {
          this.$Message.error('获取文件地址失败!' + err.message)
          reject(err)
        })
      })
    },
    handleFormatError () {
      this.$Notice.warning({
        title: '文件格式不正确',
        desc: '上传文件格式不正确。'
      })
    },
    handleExceededSize () {
      this.$Notice.warning({
        title: '文件大小超出限制',
        desc: '上传文件大小超出限制范围。'
      })
    },
    randomString (len) {
      len = len || 32
      var chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678'
      var maxPos = chars.length
      var pwd = ''
      for (let i = 0; i < len; i++) {
        pwd += chars.charAt(Math.floor(Math.random() * maxPos))
      }
      return pwd
    },
    getSuffix (filename) {
      let pos = filename.lastIndexOf('.')
      let suffix = ''
      if (pos !== -1) {
        suffix = filename.substring(pos)
      }
      return suffix
    },
    addListItem (question) {
      if (question.value && question.value instanceof Array) {
        question.value.push({
          placeholder: `填写${question.title}事由`,
          value: '',
          required: true
        })
      } else {
        question.value = [{
          placeholder: `填写${question.title}事由`,
          value: '',
          required: true
        }]
      }
      this.calculate(question.name)
    },
    removeListItem (item, question) {
      let itemIdx = question.value.findIndex(o => o === item)
      question.value.splice(itemIdx, 1)
      this.calculate(question.name)
    },
    addAdjustedListItem (question) {
      if (question.adjustedValue && question.adjustedValue instanceof Array) {
        console.log(true)
        this.$nextTick(() => {
          if (question.type === 7) {
            question.adjustedValue.push({
              placeholder: `填写${question.title}事由`,
              value: '',
              required: true,
              detaial: null
            })
          } else {
            question.adjustedValue.push({
              placeholder: `填写${question.title}事由`,
              value: '',
              required: true
            })
          }
        })
      } else {
        if (question.type === 7) {
          question.adjustedValue = [{
            placeholder: `填写${question.title}事由`,
            value: '',
            required: true,
            detaial: null
          }]
        } else {
          question.adjustedValue = [{
            placeholder: `填写${question.title}事由`,
            value: '',
            required: true
          }]
        }
      }
      this.calculate(question.name)
    },
    removeAdjustedListItem (item, question) {
      let itemIdx = question.adjustedValue.findIndex(o => o === item)
      question.adjustedValue.splice(itemIdx, 1)
      this.calculate(question.name)
    },
    calculate (name) {
      if (name) {
        let section = this.paper.sections.find(o => o.name === name)
        if (section) {
          if (section.isAttachment) {
            return 0
          }
          let questions = section.questions
          questions.forEach((question) => {
            this.calculateQuestion(question)
          })
          this.calculateSection(section)
        } else {
          let questionItem, sectionItem
          this.paper.sections.forEach((sec) => {
            if (sec.questions && sec.questions instanceof Array) {
              sec.questions.forEach((q) => {
                if (q.name === name) {
                  questionItem = q
                  sectionItem = sec
                }
              })
            }
          })
          if (questionItem) {
            this.calculateQuestion(questionItem)
            this.calculateSection(sectionItem)
          }
        }
      } else {
        // 全部计算
        let accumulation = 0
        const parser = math.parser()
        this.paper.sections.forEach((sec) => {
          if (sec.questions && sec.questions instanceof Array) {
            sec.questions.forEach((q) => {
              this.calculateQuestion(q)
            })
          }
          this.calculateSection(sec)
          if (!this.paper.scoreFormula) {
            accumulation += sec.calculatedScore
          } else {
            parser.evaluate(`${sec.name} = ${sec.calculatedScore}`)
          }
        })
        if (this.checkIsVeto(true)) {
          console.log('veto')
          this.paper.adjustedScore = -999
          return -999
        }
        if (this.paper.scoreFormula) {
          let result = parser.evaluate(this.paper.scoreFormula)
          accumulation = result
        }
        this.paper.adjustedScore = Math.round(accumulation * 100) / 100
        console.log(this.paper.adjustedScore)
      }
    },
    checkIsVeto (isAudit = true) {
      let isVeto = false
      this.paper.sections.forEach((sec) => {
        sec.questions.forEach((q) => {
          if (q.type === 3) {
            if (isAudit) {
              if (q.adjustedValue) {
                isVeto = true
              }
            } else {
              if (q.value) {
                isVeto = true
              }
            }
          }
        })
      })
      return isVeto
    },
    calculateQuestion (questionItem) {
      let isAdjust = questionItem.adjustedValue !== null && questionItem.adjustedValue !== undefined
      if ([0, 1].indexOf(questionItem.type) >= 0) {
        if (questionItem.needExtInput) {
          let options = questionItem.options
          options.forEach((opt) => {
            if (opt.adjustedValue !== null && opt.adjustedValue !== undefined) {
              isAdjust |= true
            }
          })
        }
      }
      if (questionItem.type === 5) {
        if (isAdjust) {
          questionItem.adjustedScore = 0
        } else {
          questionItem.calculatedScore = 0
        }
        return 0
      }
      if (questionItem.type === 3) {
        if (isAdjust) {
          if (questionItem.adjustedValue) {
            questionItem.adjustedScore = -999
            return -999
          }
        } else {
          if (questionItem.value) {
            questionItem.calculatedScore = -999
            return -999
          }
        }
      }
      if (!questionItem.scoreFormula) {
        if (isAdjust) {
          questionItem.adjustedScore = questionItem.adjustedValue
          return questionItem.adjustedValue
        } else {
          questionItem.calculatedScore = questionItem.value
          return questionItem.value
        }
      }
      let dic = {
        VALUE: isAdjust ? questionItem.adjustedValue : questionItem.value
      }
      if (questionItem.type === 4) {
        dic = {
          COUNT: isAdjust ? questionItem.adjustedValue.length : questionItem.value.length
        }
      }
      if (questionItem.type === 7) {
        dic = {}
        dic['DISTINCT_CAT_COUNT'] = 0
        try {
          let val = isAdjust ? questionItem.adjustedValue : questionItem.value
          let options = JSON.parse(questionItem.extInfo)
          options.forEach((opt) => {
            let ct = val.filter((item) => {return item.value == opt.value}).length
            dic['COUNT_' + opt.value] = ct
            if (ct) {
              dic['DISTINCT_CAT_COUNT'] += 1
            }
          })
        } catch (err) {
          console.log(err)
        }
      } else if ([0, 1].indexOf(questionItem.type) >= 0) {
        if (questionItem.needExtInfo) {
          let val = isAdjust ? questionItem.adjustedOptionValue : questionItem.optionValue
          if (questionItem.extInfo && val !== null && val !== undefined) {
            dic['OPTION_VALUE'] = val
          }
        } else if (questionItem.needExtInput) {
          questionItem.options.forEach((opt, optIdx) => {
            let isOptAdjusted = opt.adjustedValue !== null && opt.adjustedValue !== undefined
            let val = isOptAdjusted ? opt.adjustedValue : opt.value
            dic[`OPTION_VALUE${optIdx}`] = val || 0
          })
        }
      }
      const parser = math.parser()
      const questionValueParser = math.parser()
      for (let key in dic) {
        if (dic[key] !== null && dic[key] !== undefined) {
          parser.evaluate(`${key} = ${dic[key]}`)
          questionValueParser.evaluate(`${key} = ${dic[key]}`)
        }
      }
      if (questionItem.scoreFormula) {
        let globalRefRegx = /\$[A-Za-z]\w+\$/g
        let matches = Array.from(questionItem.scoreFormula.matchAll(globalRefRegx))
        matches.forEach((match) => {
          let variable = match[0]
          let variableName = variable.substr(1, variable.length - 2)
          let variableQuestion = this.getQuestionByName(variableName)
          let isVariableQuestionAdjust = variableQuestion.adjustedValue !== null && variableQuestion.adjustedValue !== undefined
          let variableQuestionValue = isVariableQuestionAdjust ? variableQuestion.adjustedValue : variableQuestion.value
          parser.evaluate(`${variable} = ${variableQuestionValue}`)
          questionValueParser.evaluate(`${variable} = ${variableQuestionValue}`)
        })
      }
      
      if (questionItem.defaultValue && questionItem.defaultValue.indexOf('=') === 0) {
        // 动态计算值
        let valueFormula = questionItem.defaultValue.substr(1)
        let questionValue = questionValueParser.evaluate(valueFormula)
        if (isAdjust) {
          questionItem.adjustedValue = questionValue
        } else {
          questionItem.value = questionValue
        }
      }
      let result = parser.evaluate(questionItem.scoreFormula)
      if (isAdjust) {
        questionItem.adjustedScore = result
      } else {
        questionItem.calculatedScore = result
      }
      // 通知引用方更新
      let globalVar = this.globalVars[questionItem.name]
      if (globalVar) {
        globalVar.forEach((g) => {
          this.calculate(g)
        })
      }
      return result
    },
    getQuestionByName (questionName) {
      let question = null
      this.paper.sections.forEach(s => {
        s.questions.forEach((q) => {
          if (q.name === questionName) {
            question = q
          }
        })
      })
      return question
    },
    calculateSection (sectionItem) {
      if (sectionItem.isAttachment) {
        sectionItem.calculatedScore = 0
        return 0
      }
      let sum = 0
      let questions = sectionItem.questions
      questions.forEach((q) => {
        let isAdjust = q.adjustedValue !== null && q.adjustedValue !== undefined
        let qScore = isAdjust ? q.adjustedScore : q.calculatedScore
        sum += qScore
        console.log(q.title, isAdjust, qScore, sum)
      })
      if (!sectionItem.scoreFormula) {
        sectionItem.calculatedScore = 0
        questions.forEach((q) => {
          let isAdjust = q.adjustedValue !== null && q.adjustedValue !== undefined
          let qValue = isAdjust ? q.adjustedValue : q.value
          let qScore = isAdjust ? q.adjustedScore : q.calculatedScore
          if (q.type === 3 && qValue) {
            sectionItem.calculatedScore = -999
            return -999
          }
          sectionItem.calculatedScore += qScore
          console.log(sectionItem.title, sectionItem.calculatedScore, qScore)
        })
        return sectionItem.calculatedScore
      }
      const parser = math.parser()
      parser.evaluate(`SUM = ${sum}`)
      questions.forEach((q) => {
        let isAdjust = q.adjustedValue !== null && q.adjustedValue !== undefined
        let qScore = isAdjust ? q.adjustedScore : q.calculatedScore
        parser.evaluate(`${q.name} = ${qScore}`)
      })
      let result = parser.evaluate(sectionItem.scoreFormula)
      sectionItem.calculatedScore = result
      return result
    },
    submit () {
      this.$refs.auditForm.validate((valid) => {
        console.log(valid)
        if (valid) {
          this.loading = true
          this.$Spin.show()
          this.calculate()
          this.$nextTick(() => {
            Api.Appraisal.auditAppraisalPaper({
              id: this.record.tid,
              grade: this.paper.grade,
              remark: this.paper.remark,
              adjustedScore: this.paper.adjustedScore,
              rawJson: JSON.stringify(this.paper)
            }).then(() => {
              this.$Message.success('保存成功!')
              this.loading = false
              this.$Spin.hide()
              this.$router.back()
            })
            .catch(err => {
              console.log('err', err)
              this.$Message.error('提交失败!' + err.message)
              this.loading = false
              this.$Spin.hide()
            })
          })
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.attachments {
  display: flex;
  flex-direction: row;
  margin: 10px 0;
  flex-wrap: wrap;
}
.attachment-thumb {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-size: cover;
  background-color: #efefef;
  width: 100px;
  height: 100px;
  margin-right: 4px;
  transition: all .2s ease-in-out;
  cursor: pointer;
  padding: 3px;
  border: 1px solid #d2d2d2;
  position: relative;
  &:hover {
    border: 1px solid rgb(65,157,253);
    background-color: #fff;
  }
  overflow: hidden;
  img {
    width: 100%;
  }
  .attachment-thumb-cover{
    opacity: 0;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0,0,0,.6);
    transition: all .3s linear;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
  }
  &:hover .attachment-thumb-cover{
    opacity: 1;
  }
  .attachment-thumb-cover i{
    color: #fff;
    font-size: 20px;
    cursor: pointer;
    margin: 0 5px;
  }
}
.question-list-item-list {
  list-style-type: none;
  counter-reset: css-counter 0;
  .question-list-item {
    counter-increment: css-counter 1;
    &::before {
      content: counter(css-counter) ". ";
    }
  }
  .question-list-item:not(:last-child) {
    border-bottom: 1px solid #ccc;
  }
}
</style>